import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import DefaultLayout from '../../components/DefaultLayout';
import { Tabs } from '../../../ui';
import CategoryTab from './components/CategoryTab';
import TopCategoriesTab from './components/TopCategoriesTab';
import ContractInformationTab from './components/ClassifiersTab';
import AuthenticationTab from './components/AuthentificationTab';
import SocialNetworksTab from './components/SocialNetworksTab';

const ClassifiersPage = () => {
  const intl = useIntl();

  const breadCrumbs = [
    {
      title: intl.formatMessage({ id: 'navigation.beginning' }),
    },
    {
      title: intl.formatMessage({ id: 'navigation.classifiers' }),
    },
  ];

  const items = useMemo(
    () => [
      {
        key: 'category',
        label: intl.formatMessage({ id: 'navigation.category' }),
        children: <CategoryTab />,
      },
      {
        key: 'top_category',
        label: intl.formatMessage({ id: 'navigation.top_categories' }),
        children: <TopCategoriesTab />,
      },
      {
        key: 'contract_information',
        label: intl.formatMessage({ id: 'navigation.contract_information' }),
        children: <ContractInformationTab />,
      },
      {
        key: 'authentication_information',
        label: intl.formatMessage({
          id: 'classifiers.authentication_information',
        }),
        children: <AuthenticationTab />,
      },
      {
        key: 'social_networks',
        label: intl.formatMessage({ id: 'classifiers.social_networks' }),
        children: <SocialNetworksTab />,
      },
    ],
    [intl]
  );

  return (
    <DefaultLayout.PageLayout breadcrumbs={breadCrumbs}>
      <DefaultLayout.PageContent>
        <Tabs items={items} />
      </DefaultLayout.PageContent>
    </DefaultLayout.PageLayout>
  );
};

export default ClassifiersPage;
